import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { SequenceType, SerialSequenceModal } from './SerialSequenceModal'

type SerialSequenceCreateActivityProps = {
  refetchQuery: string
  name?: string
  legalEntityId?: string
  /** If provided, the type is fixed. If not provided, user can select in the modal. */
  sequenceType?: SequenceType
}

export const SerialSequenceCreateActivity: ActivityComponent<SerialSequenceCreateActivityProps> = (
  data
) => {
  const { open, closeActivity } = useActivity()

  return (
    <SerialSequenceModal
      isOpen={open}
      onClose={closeActivity}
      refetchQuery={data.refetchQuery}
      name={data.name}
      legalEntityId={data.legalEntityId ? Number(data.legalEntityId) : undefined}
      sequenceType={data.sequenceType}
    />
  )
}
